export * from './FI';
export * from './CRB';
export type ActivityType = 'deposits' | 'sales' | 'daily-summaries';
